<div class="health">
   <div class="bar"></div>
   <span class="stat">
      <span class="left">{{successful}}</span>
      <span class="right">{{total}}</span>
   </span>
</div>